<body>
  <div class="container">
    <!-- Logo -->
    <img
      src="https://blogger.googleusercontent.com/img/a/AVvXsEhfC-DB-VoMSnN6TqSgnY8JsOWWrUDB9rEC3bhPsyUjrJ8ANniwzlsQh2JcjhlD84AVHI_6hm6alj4uSi2hYWw6DEbgW0ZEICgIH86WqwTEIcpNzCaaY78icJo_RbqFxjWmS6aWEOZb64ZZhOAUHptVgto6RrSnhjoD61wBycNe6IwVfC4GAU4mUx6bepHT"
      alt="Logo"
      class="logo"
    />

    <!-- Información -->
    <div class="info">
      <h2 class="info-item">
        <strong>N° Factura:</strong>
        {{ numfactura }}
      </h2>
      <h2 class="info-item">
        <strong>Valor de factura:</strong>
        ${{ valor }}
      </h2>
      <h2 class="info-item">
        <strong>Emisor:</strong>
        {{ nombreInstitucion }}
      </h2>
      <h2 class="info-item" [ngClass]="{ approved: estado === 'MÉTODO APROBADO', rejected: estado === 'MÉTODO RECHAZADO' }">
        <strong>Estado factura:</strong>
        {{ estado }}
      </h2>
    </div>

    <!-- Footer con un posible botón de acción -->
    <!-- <div class="footer">
        <a href="/" class="button">Volver al inicio</a>
      </div> -->
  </div>
</body>
